<template>
  <el-row class="add-news">
    <el-col :span="12">
      <strong>{{ id ? "Tovarni tahrirlash" : `Tovar qo'shish` }}</strong>
    </el-col>

    <el-col :span="24" style="margin-top: 10px">
      <!-- Write window closed (FRONTEND_PRODUCT_WRITE_WINDOW.md §4.3/§4.4): the
           selected/loaded board's review period has started, so the whole form
           is read-only. Also guards direct-URL access to a frozen board. -->
      <el-alert
          v-if="formLocked"
          class="window-note"
          type="warning"
          show-icon
          :closable="false"
          title="Bu doska uchun review davri boshlangan — tovarni o'zgartirib bo'lmaydi (faqat ko'rish mumkin)."
      />
      <el-form label-position="top" ref="formRef" :model="productModel" :disabled="formLocked">
        <el-form-item label="Doskani tanlang"
                      prop="board_id"
                      :rules="[{required: true, message: 'Majburiy maydon', trigger: 'change'}]"
        >
          <el-select size="large" v-model="productModel.board_id" style="width: 100%">
            <!-- Closed boards are unselectable — the backend checks BOTH the
                 current and the target board, so offering a closed target is a
                 guaranteed 451 (§4.3). -->
            <el-option
                v-for="board in boards"
                :key="board.id"
                :value="board.id"
                :disabled="isBoardClosed(board)"
                :label="
                board.title +
                ' ' +
                board.season +
                '-' +
                'mavsum ' +
                board.year +
                ' yil' +
                (isBoardClosed(board) ? ' (review boshlangan)' : '')
              "
            />
          </el-select>
        </el-form-item>
        <el-tabs v-model="activeName">
          <el-tab-pane label="UZB" name="uz">
            <el-form-item
                label="Sarlavha"
                prop="title.uz_lat"
                :rules="[{ required: true, message: 'Sarlavha majburiy (Uz)' }]"
            >
              <el-input
                  placeholder="Sarlavhani kiriting (Uz)"
                  v-model="productModel.title.uz_lat"
                  type="text"
                  autocomplete="off"
              />
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="UZB Krill" name="uz_cyr">
            <el-form-item
                label="Sarlavha"
                prop="title.uz_cyr"
                :rules="[{ required: true, message: 'Sarlavha majburiy (UzKr)' }]"
            >
              <el-input
                  placeholder="Sarlavhani kiriting (UzKr)"
                  v-model="productModel.title.uz_cyr"
                  type="text"
                  autocomplete="off"
              />
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="RU" name="ru">
            <el-form-item
                label="Sarlavha"
                prop="title.ru"
                :rules="[{ required: true, message: 'Sarlavha majburiy (Ru)' }]"
            >
              <el-input
                  placeholder="Sarlavhani kiriting (Ru)"
                  v-model.number="productModel.title.ru"
                  type="text"
                  autocomplete="off"
              />
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="ENG" name="en">
            <el-form-item
                label="Sarlavha (En)"
                prop="title.en"
                :rules="[{ required: true, message: 'Sarlavha majburiy (En)' }]"
            >
              <el-input
                  placeholder="Sarlavhani kiriting (En)"
                  v-model.number="productModel.title.en"
                  type="text"
                  autocomplete="off"
              />
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="KP" name="kp">
            <el-form-item
                label="Sarlavha (Kp)"
                prop="title.kr"
                :rules="[{ required: true, message: 'Sarlavha majburiy (Kp)' }]"
            >
              <el-input
                  placeholder="Sarlavhani kiriting (Kp)"
                  v-model.number="productModel.title.kr"
                  type="text"
                  autocomplete="off"
              />
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
        <el-form-item
            label="Tashabbus kategoriyasi"
            prop="initiative_category_id"
            :rules="[
            { required: true, message: 'Tashabbus kategoriyasini tanlash majburiy' },
            { validator: validateInitiativeCategory, trigger: 'change' },
          ]"
        >
          <!-- Editing a product whose category has since been flipped to
               is_equipable=0: the current selection is no longer offered in the
               options. Warn, keep it visibly-invalid in the select, and block
               submit until a valid (equipable) category is picked (§4). -->
          <el-alert
              v-if="invalidCategory"
              class="invalid-cat-banner"
              type="warning"
              show-icon
              :closable="false"
              title="Bu turkumga endi tovar biriktirib bo'lmaydi — saqlashdan oldin boshqa turkum tanlang."
          />
          <el-select
              v-model="productModel.initiative_category_id"
              placeholder="Tashabbus kategoriyasini tanlang"
              filterable
              :loading="categoriesLoading"
              loading-text="Yuklanmoqda..."
              no-data-text="Kategoriyalar topilmadi"
              style="width: 100%"
              @change="applyInvalidCategoryCheck"
          >
            <!-- Only equipable categories are selectable options. The stale
                 non-equipable value gets a single struck-through option so the
                 select can still render what is currently stored. -->
            <el-option
                v-if="invalidCategory"
                :value="invalidCategory.id"
                :key="`invalid-${invalidCategory.id}`"
                :label="`${invalidCategory.title} (endi biriktirib bo'lmaydi)`"
                class="invalid-option"
                disabled
            />
            <el-option
                v-for="category in categories"
                :value="category.id"
                :key="category.id"
                :label="category.title"
            />
          </el-select>
          <el-button
              v-if="categoriesError"
              link
              type="primary"
              @click="getCategories"
          >Qayta urinish
          </el-button>
        </el-form-item>
        <el-form-item
            label="O'lchov birligi"
            prop="unit_of_measure"
            :rules="[
            { required: true, message: 'O\'lchov birligini tanlash majburiy' },
          ]"
        >
          <el-select
              v-model="productModel.unit_of_measure"
              placeholder="O'lchov birligi"
              style="width: 100%"
          >
            <el-option
                v-for="unit in units"
                :value="unit.value"
                :key="unit.name"
                :label="unit.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item
            label="Tovar soni"
            prop="max_available"
            :rules="[
            { required: true, message: 'Tovar sonini kiritish majburiy' },
            { validator: validatePositiveCount, trigger: 'blur' },
          ]"
        >
          <el-input
              placeholder="Tovar sonini kiriting"
              v-model="productModel.max_available"
              type="number"
              autocomplete="off"
          />
        </el-form-item>
        <el-form-item
            label="Narx"
            prop="price"
            :rules="[
            { required: true, message: 'Narxni kiritish majburiy' },
          ]"
        >
          <el-input
              placeholder="Narxni kiriting"
              v-model="productModel.price"
              type="number"
              autocomplete="off"
          />
        </el-form-item>

        <div class="mt-15 text-right">
          <router-link
              to="/app/products/list"
              class="el-button el-button--danger"
          >
            Bekor qilish
          </router-link>
          <el-button type="primary" :disabled="formLocked" @click="submitForm(formRef)"
          >Saqlash
          </el-button
          >
        </div>
      </el-form>
    </el-col>
  </el-row>
</template>

<script setup>
import {computed, onMounted, reactive, ref} from "vue";
import {ElMessage} from "element-plus";
import http from "@/http";
import router from "@/router";
import {useRoute} from "vue-router";


const formRef = ref();
const loading = ref(false);
const categories = ref([]);
const categoriesLoading = ref(false);
const categoriesError = ref(false);
const units = ref([{value: "collection", name: "To'plam"}, {value: "piece", name: "Dona"}]);
const activeName = ref("uz");

// Product write window (FRONTEND_PRODUCT_WRITE_WINDOW.md §4): a board is frozen
// once its REVIEW period has started (now >= review_start_date). Compare
// instants — the date carries a timezone offset. Fail open when the field is
// absent (the 451 backstop still covers it).
const isBoardClosed = (board) => {
  const start = board?.review_start_date;
  if (!start) return false;
  return Date.now() >= new Date(start).getTime();
};
// Set true by the 451 backstop after a proven-closed write (§4.5).
const forcedClosed = ref(false);
// The form is read-only when its selected/loaded board is closed: on edit this
// guards a direct-URL open of a product on a frozen board (§4.4); on create the
// closed board can't be picked (its option is disabled), so this stays false.
const formLocked = computed(() => {
  if (forcedClosed.value) return true;
  const board = boards.value.find((b) => b.id === productModel.board_id);
  return board ? isBoardClosed(board) : false;
});
const boards = ref([]);

const route = useRoute();
const {id} = route.params;
let productModel = reactive({
  title: {
    uz_lat: "",
    uz_cyr: "",
    ru: "",
    en: "",
    kr: "",
  },
  // Direct link to an initiative_category (FRONTEND_ADMIN_PRODUCTS.md §2).
  // Replaces the legacy product_category `category_id` in the authoring flow.
  initiative_category_id: "",
  unit_of_measure: "",
  max_available: null,
  price: null,
  board_id: null
});

// Backend treats a numeric `required` field as invalid when it is 0 (Go
// zero-value), so `initiative_category_id: 0` / `board_id: 0` /
// `max_available: 0` are rejected exactly like a missing field (§2.1). Block
// them client-side. `price: 0` is intentionally allowed (no required tag).
const validateInitiativeCategory = (rule, value, callback) => {
  if (!value || Number(value) <= 0) {
    callback(new Error("Tashabbus kategoriyasini tanlash majburiy"));
  } else if (invalidCategory.value && invalidCategory.value.id === value) {
    // Stale non-equipable selection is still active — force a valid pick (§4).
    callback(new Error("Bu turkumga endi tovar biriktirib bo'lmaydi — boshqa turkum tanlang"));
  } else {
    callback();
  }
};

// Current selection points at a category that is no longer equipable (not in
// the filtered options). Holds {id, title} to drive the warning banner and the
// struck-through option; null when the selection is valid (§4).
const invalidCategory = ref(null);
const applyInvalidCategoryCheck = () => {
  const selId = productModel.initiative_category_id;
  if (!selId) {
    invalidCategory.value = null;
    return;
  }
  const found = categories.value.find((c) => c.id === selId);
  invalidCategory.value = found
      ? null
      : {id: selId, title: loadedCategoryTitle.value || `ID: ${selId}`};
};
const validatePositiveCount = (rule, value, callback) => {
  if (value === null || value === "" || Number(value) <= 0) {
    callback(new Error("Tovar soni 0 dan katta bo'lishi kerak"));
  } else {
    callback();
  }
};

const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      loading.value = true;
      // Build an explicit payload — never forward the legacy `category_id`
      // (or other read-only GET fields like `category`/`is_active`) that an
      // edit-load may have merged into the model. Saving now always sets
      // `initiative_category_id` and clears the legacy link server-side (§2.2).
      const payload = {
        title: productModel.title,
        initiative_category_id: productModel.initiative_category_id,
        unit_of_measure: productModel.unit_of_measure,
        max_available: parseInt(productModel.max_available),
        price: parseInt(productModel.price) || 0,
        board_id: productModel.board_id,
      };
      http({
        url: `api/v1/products${id ? `/${id}` : ""}`,
        data: payload,
        method: id ? "put" : "post",
        headers: {},
      })
          .then(() => {
            router.push("/app/products/list");
          })
          .catch((err) => {
            const response = err?.response;
            // Review window closed on the current or target board (§4.5): lock
            // the form read-only and surface the message; don't leave it
            // interactive after a proven-closed write.
            if (
                response?.status === 451 &&
                response?.data?.specific_slug === "board_window_closed"
            ) {
              forcedClosed.value = true;
              ElMessage.warning(
                  response?.data?.message ||
                  "Review boshlangan — tovarni o'zgartirib bo'lmaydi."
              );
              return;
            }
            // Otherwise surface the backend's actual message (e.g. unknown
            // category, invalid unit) verbatim rather than a generic fallback (§6).
            ElMessage.error(response?.data?.message || `Xatolik qayta urinib ko'ring`);
          })
          .finally(() => {
            loading.value = false;
          });
    } else {
      const errors = [];
      for (const keys in fields) {
        fields[keys].map((item) => {
          errors.push(item);
        });
      }
      errors.map((error) => {
        ElMessage.error(error.message);
      });
      console.log("error submit!", fields);
    }
  });
};

const getBoards = () => {
  loading.value = true;
  return http({url: `api/v1/boards`, params: {status: 1}})
      .then(({data}) => {
        boards.value = data.boards;
      })
      .catch((err) => {
        ElMessage.error(
            err.response.data.message || `Hatolik qayta urinib ko'ring`
        );
      })
      .finally(() => {
        loading.value = false;
      });
};

// Options for the category select come from the SAME source as the citizen
// picker and ministry-manager screens — the initiative-categories list, never
// the legacy product-categories endpoint (§4, §5.1).
const getCategories = () => {
  categoriesLoading.value = true;
  categoriesError.value = false;
  return http
      .get("api/v1/initiative-categories", {params: {is_active: 1, limit: 1000}})
      .then((res) => {
        // v2: only equipable categories may hold products — the backend rejects
        // the rest on POST/PUT. Filter client-side (string compare; "0" is
        // truthy in JS) so a guaranteed-error option is never offered (§4).
        categories.value = (res.data.initiative_categories || []).filter(
            (c) => c.is_equipable === "1"
        );
      })
      .catch(() => {
        categoriesError.value = true;
        ElMessage.error("Kategoriyalarni yuklashda xatolik");
      })
      .finally(() => {
        categoriesLoading.value = false;
      });
};

// v2: GET /products/:id now returns a resolved `initiative_category_id` for
// BOTH new-style and legacy products (COALESCE server-side — §2.3), so we
// preselect straight from that id. No title-matching workaround anymore. The
// `initiative_category` title is kept only to label a now-non-equipable
// selection in the warning banner (§4). `0` means genuinely no link (dirty
// legacy data) — leave the select empty and force the admin to choose.
const loadedCategoryTitle = ref("");

const loadProduct = () => {
  return http.get(`api/v1/products/${id}`).then((res) => {
    const data = res.data || {};
    // `title` may arrive as a per-language object (real response) or, per the
    // spec example, a flat hl-resolved string — handle both.
    if (data.title && typeof data.title === "object") {
      Object.assign(productModel.title, data.title);
    } else if (typeof data.title === "string") {
      Object.keys(productModel.title).forEach((k) => {
        productModel.title[k] = data.title;
      });
    }
    // Do NOT read the legacy `category_id` (product_category) — use the
    // backend-resolved initiative_category_id directly.
    loadedCategoryTitle.value = data.initiative_category || "";
    productModel.initiative_category_id = data.initiative_category_id || "";
    productModel.unit_of_measure = data.unit_of_measure || "";
    productModel.max_available = data.max_available ?? null;
    productModel.price = data.price ?? null;
    productModel.board_id = data.board_id || null;
  }).catch((err) => {
    ElMessage.error(err?.response?.data?.message || "Tovarni yuklashda xatolik");
  });
};

onMounted(async () => {
  // Fetch categories, product and boards in parallel so the edit form can
  // render its preselected category without a sequential flicker (§6).
  const tasks = [getCategories(), getBoards()];
  if (id) tasks.push(loadProduct());
  await Promise.all(tasks);
  // Once both options and the product are in, flag a stale non-equipable
  // selection so the banner/blocking kicks in on the edit form (§4).
  if (id) applyInvalidCategoryCheck();
});
</script>

<style>
.file-upload label {
  margin: 0 !important;
}

.add-news .el-input__wrapper {
  padding: 0 1rem !important;
}

.input-hidden .el-form-item__content {
  height: 0;
  padding: 0;
}

/* Stale non-equipable selection — teleported to <body>, so styled globally. */
.el-select-dropdown__item.invalid-option {
  text-decoration: line-through;
  color: var(--el-color-warning);
}
</style>
<style scoped lang="scss">
.linkButtons {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
  width: 450px;

  button {
    width: 100%;
  }
}

.file-upload-button {
  padding: 1rem;
  border: 1px dotted #e1e1e1;
  border-radius: 8px;
  overflow: hidden;
  color: #808080;
  display: block;
  max-width: 240px;
  cursor: pointer;

  &:hover {
    background-color: #e1e1e1;
  }

  img {
    max-width: 100%;
    object-fit: cover;
  }
}

.text-right {
  text-align: right;
}

.invalid-cat-banner {
  margin-bottom: 8px;
}

.window-note {
  margin-bottom: 12px;
}

a {
  text-decoration: none;
}

.form-row {
  display: flex;
  gap: 15px;
}
</style>
